import config from 'config'
import React from 'react'
import styles from './styles.module.scss'
import { decode } from 'html-entities'
import Badge from 'srcReact/components/common2/Badge'
import { redirectToPage } from 'srcReact/helpers/history'

function GroupsMixrsList({ id, title, picture, notifications, type, closeMenu }) {
  const handleGroupsMixrsList = () => {
    closeMenu()
    if (type === 'groups') {
      redirectToPage(`/0/home/group/${id}`)
      return
    }
    redirectToPage(`/0/home/event/${id}`, true)
  }

  return (
    <div role='button' className={styles.groupsMixrsListWrapper} onClick={handleGroupsMixrsList}>
      <div className={styles.groupsMixrsContent}>
        <div className={styles.picture}>
          {picture ? (
            <img src={picture} alt={decode(title)} />
          ) : (
            <img src={require('srcReact/assets/images/background-default-mixr.jpg')} alt='default' />
          )}
        </div>
        <div className={styles.title}>{title}</div>
        {notifications >= 1 && <Badge size='medium' color='green' text={notifications} />}
      </div>
    </div>
  )
}

export default GroupsMixrsList
